import React from "react";
import { VisualComponent } from "../../../types/fancy-base-attributes";
import { cn } from "../../../utils/shorthands";
import * as scss from "./divider.scss";

export function Divider(props: VisualComponent): JSX.Element {
	const { style, className } = props;
	return <div data-component="divider" style={style} className={cn(className, scss.divider)} />;
}
